<!--
 * @Author: HWD
 * @Date: 2021-11-04 09:27:16
 * @LastEditors: HWD
 * @LastEditTime: 2021-11-19 17:02:00
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
-->
<template>
  <div>  

    <!-- <el-carousel :interval="window.interval" arrow="always">
        <el-carousel-item v-for="(item, index) in window.adpic" :key="index">
          <img :src="item.img" />
        </el-carousel-item>  
    </el-carousel> -->
    <div class="spreadqrcode">
      <img id="qrcode" :class="isVip ? 'vip' : ''" :src="qrCode" />
    </div>
  </div>
</template>

<script>
import collectionError from "../utils/qrcode";
// import QrCode from "@/components/QrCode"
// import SpreadRegister from "@/components/SpreadRegister"
import Fetch from '../utils/fetch';
export default {

//   components: {
//     QrCode,
//     SpreadRegister
//   },
  // props: {
  //   source: {
  //     type: String,
  //     required: true,
  //   },
  // },
  data() {
    return {
      isVip: false,
      qrCode: "",
      HGCode:"aHR0cHM6Ly9oa2tqLm5ldC5jbi9waHBhcGkvcXJjb2RlLnBocD90ZXh0PQ==",   
      //SpreadUrl:"aHR0cHM6Ly9oa2tqLm5ldC5jbi9waHBhcGkvcXJjb2RlLnBocD90ZXh0PWh0dHBzOi8vaGtrai5uZXQuY24vbW92ZWNhci9pbmRleC5odG1sP3NwcmVhZGlkPQ==",
      SpreadUrl:'aHR0cHM6Ly9oa2tqLm5ldC5jbi9waHBhcGkvcXJjb2RlLnBocD90ZXh0PWh0dHBzOi8vaGtrai5uZXQuY24vbW92ZWNhci9zcHJlYWQ/aWQ9',
      source:'12345678',
      window:{
        interval:5000,
        showState:true,
        adpic: [],
        adpic1: [
          {
            img: "https://img-s-msn-com.akamaized.net/tenant/amp/entityid/AAQ20cO.img?h=412&w=624&m=6&q=60&o=f&l=f&x=408&y=143",
          },
          {
            img: "https://x0.ifengimg.com/ucms/2021_44/F7B09660AB87809070A5D186D796F3E105D8C133_size421_w1080_h602.png",
          },
        ],
        
      },
   
    };
  },
  created() {
    //this.getUrlObj()
    this.getQrCode()
    this.source = this.getUrlObj().id
    this.getData()
    this.QrCode()

    
  },
  mounted() {
      //setTimeout(this.aa,5000)
  },
  updated() {},
  //computed () {},
  methods: {
    getUrlObj() {
      var ret = {};
      console.log(location.search, location);
      var search = location.search.slice(1);
      console.log(search);
      search.replace(/([^?&]+)=([^?&]+)/g, function (s, v, k) {
        ret[v] = decodeURIComponent(k);
        //return k + "=" + v;
      });
      console.log(ret);
      return ret;
    },
    getQrCode() {
      collectionError.hCode(
        "aHR0cDovL2hra2oubmV0LmNuL2FwaS9xcmNvZGUucGhwP3RleHQ9c2lnbmFscjovLw=="
      );
      console.log(collectionError.hCode(this.HGCode));
      console.log(collectionError.hCode(this.SpreadUrl));
      collectionError.hCode("aHR0cHM6Ly9oa2tqLm5ldC5jbi9waHBhcGkvcXJjb2RlLnBocD90ZXh0PQ==");
      collectionError.hCode("aHR0cHM6Ly9oa2tqLm5ldC5jbi9tb3ZlY2FyL2luZGV4Lmh0bWw/aWQ9TU9WRUNBUjIwMjExMDI4TlVNMDAwMQ==");
      console.log(collectionError.wcode("https://hkkj.net.cn/phpapi/qrcode.php?text=https://hkkj.net.cn/movecar/index.html?id=MOVECAR20211028NUM0001"))
      console.log(collectionError.wcode("https://hkkj.net.cn/phpapi/qrcode.php?text=https://hkkj.net.cn/movecar/index.html?spreadid="))
      console.log(collectionError.wcode("https://hkkj.net.cn/phpapi/qrcode.php?text=https://hkkj.net.cn/movecar/spread?id="))
      console.log(collectionError.wcode('MOVECAR20211028NUM0001'));
      collectionError.hCode("aHR0cHM6Ly9oa2tqLm5ldC5jbi9tb3ZlY2FyL2luZGV4Lmh0bWw/aWQ9");
      console.log(collectionError.wcode(this.source));
      collectionError.hCode("TU9WRUNBUjIwMjExMDI4TlVNMDAwMQ==");
      collectionError.hCode("aHR0cHM6Ly9oa2tqLm5ldC5jbi9tb3ZlY2FyL2luZGV4Lmh0bWw/aWQ9TU9WRUNBUjIwMjExMDI4TlVNMDAwMQ==");
      console.log(
        collectionError.wcode("http://hkkj.net.cn/api/qrcode.php?text=")
      ); //aHR0cDovL2hra2oubmV0LmNuL2FwaS9xcmNvZGUucGhwP3RleHQ9
      console.log(
        collectionError.wcode("https://hkkj.net.cn/phpapi/qrcode.php?text=")
      );
      console.log(
        collectionError.wcode(
          "http://hkkj.net.cn/api/qrcode.php?text=13013072911"
        )
      ); //aHR0cDovL2hra2oubmV0LmNuL2FwaS9xcmNvZGUucGhwP3RleHQ9MTMwMTMwNzI5MTE=    https://hkkj.net.cn/phpapi/qrcode.php?text=https://hkkj.net.cn/movecar/index.html?id=MOVECAR20211028NUM0001
    },
    async getData(){
      // console.log(this.window.source)
      // const data = await Fetch("getAdInfo.php", {  });// { CarId: this.window.source }
      // console.log(data);
      // if (data.code == 200) {
      //   this.window.showState = data.data.showAd
      //   this.window.adpic = data.data.adpic;
      // }
      const data = await Fetch("spread.php",{},'POST');// { CarId: this.window.source }
      console.log(data);
    },
    QrCode() {
      let temp = collectionError.wcode( collectionError.hCode(this.SpreadUrl) + this.source);
      console.log(collectionError.hCode(this.SpreadUrl) + this.source)
      console.log(temp)
      collectionError.getHuBase64(temp, "qrcode");
      //collectionError.getBase64("https://hkkj.net.cn/phpapi/qrcode.php?text=https://hkkj.net.cn/movecar/index.html?spreadid=MOVECAR20211028NUM0001", "qrcode");
    },
    aa(){ 
      this.$router.push({
        path: '/movecar/register',
        name: 'register',
        params:{
          SpreadUserId:this.source,
        }
      })
    }
  },
};
</script>

<style scoped>
.spreadqrcode img {
  width: 8rem;
}
.vip {
  border: 0.6rem solid rgb(216, 216, 32);
  border-radius: 4px;
}
</style>
